<template>
    <svg
        class="sbs-video-player-play-toggle-icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.125 15.6291L14.875 9.99995L5.125 4.37078L5.125 15.6291ZM15.875 11.732C17.2083 10.9622 17.2083 9.03769 15.875 8.26789L6.125 2.63873C4.79167 1.86893 3.125 2.83118 3.125 4.37078L3.125 15.6291C3.125 17.1687 4.79167 18.131 6.125 17.3612L15.875 11.732Z"
            fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: 'SbsVideoPlayerPlayToggleIcon',
};
</script>

<style lang="scss">
.sbs-video-player-play-toggle-icon {
    .vjs-play-control.vjs-playing &,
    .vjs-play-control.vjs-paused.vjs-ended & {
        display: none;
    }

    .vjs-play-control:hover & {
        color: var(--video-player-theme);
        transition: color $trs-slow;
    }
}
</style>
